export default __webpack_public_path__ + "alberta-subunit.d64361b3c0d4b1257062.svg";